import { useApiQuery } from "@/lib/query";
import type { Agent, AgentSpec, HistoryPoint } from "./types";

export const useAgents = () => useApiQuery<Agent[]>("/agents");

export const useAgent = (id: string) => useApiQuery<Agent>(`/agents/${id}`, {}, { enabled: !!id });

/** The agent as a package (instructions, inputs, model, tools, output, run
 *  settings), read live from the connector like the config. `null` disables it. */
export const useAgentSpec = (id: string | null) =>
  useApiQuery<AgentSpec>(`/agents/${id}/spec`, {}, { enabled: !!id, staleTime: 30_000 });

export const useAgentHistory = (id: string) => useApiQuery<HistoryPoint[]>(`/agents/${id}/history`);
